import type { MetaFunction } from "react-router";
import Pricing from "@/pages/Pricing";

export const meta: MetaFunction = () => {
  return [
    { title: "Simple pricing. All the features. | Arcitext" },
    {
      name: "description",
      content: "The cheapest way to get started with AI-Assisted copywriting. Whether you're just starting your writing journey, or already earn money from words, Arcitext has you covered.",
    },
    {
      name: "keywords",
      content: "AI copywriting, writing coach, content strategist, copywriting tool",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com/pricing",
    },
    {
      property: "og:title",
      content: "Simple pricing. All the features. | Arcitext",
    },
    {
      property: "og:description",
      content: "The cheapest way to get started with AI-Assisted copywriting.",
    },
    {
      property: "og:url",
      content: "https://www.arcitext.com/pricing",
    },
  ];
};

// This route uses static pre-rendering
export default function PricingRoute() {
  return <Pricing />;
}
